
export interface UserInfo {
    userId: string;
    displayName: string;
    email: string;
    organizationId: string;
    organizationName?: string;
    name?: string;
    type?: UserType;
}

export enum UserType {
    AWS = 'AWS',
    COGNITO = 'Cognito',
    PARTNER = 'Partner',
}